import { render, staticRenderFns } from "./ApproverHome.vue?vue&type=template&id=3e65009e&lang=pug&"
import script from "./ApproverHome.vue?vue&type=script&lang=js&"
export * from "./ApproverHome.vue?vue&type=script&lang=js&"
import style0 from "./ApproverHome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports